<template>
  <div id="page">
    <div class="container">
      <section class="h1-wrap">
        <h4>
          <img
            src="https://www.chinanola.com/static/img/flow/nba/nbajg.png"
            alt=""
          />
        </h4>
        <div class="text-content">
          <p>
            作为国内领先的篮球领域内容服务商，数字娱乐内容提供商及数字营销服务商，我们有着丰富的爆款打造，IP孵化等经验，将打造创新型篮球领域内容服务商。将围绕篮球类赛事内容及体育创作者生态，在内容、品牌运营及商业化、直播电商、线下活动等多个领域展开深度合作。
          </p>
        </div>
      </section>

      <section class="h2-wrap">
        <h4>
          <img
            src="https://www.chinanola.com/static/img/flow/nba/nba_jzdl.png"
            alt=""
          />
        </h4>
        <div class="content-wrap">
          <div class="content">
            <div
              class="item-wrap"
              v-for="(item, index) in talentList"
              :key="item.id"
              v-if="index < 15 || moreDataShow"
            >
              <div class="img-wrap">
                <img
                  :src="
                    'https://www.chinanola.com/static/img/flow/nba/talent/talentnew' +
                    item.id +
                    '.png'
                  "
                  alt=""
                />
              </div>
              <div class="text-div">
                <p v-text="item.title"></p>
              </div>
            </div>
          </div>
          <div class="more-data" v-if="!moreDataShow">
            <span @click="moreDataShow = true">- 更多 -</span>
          </div>
        </div>
      </section>-->
      <section class="sign">
        <div class="content-wrap">
          <div class="title">
            <h4>签约入驻</h4>
          </div>
          <van-form @submit="onSubmit" class="form"
            id="signform"
            ref="form"
          >
            <div>
              <van-field
                id="dy_name"
                placeholder="抖音名称"
                autocomplete="off"
                v-model="formData.dyname"
                input-align="center"
                :rules="[{ required: true, message: '请输入抖音名称'}]"
              >
              </van-field>
            </div>
            <div>
              <van-field
                type="text"
                input-align="center"
                id="dy_id"
                autocomplete="off"
                placeholder="抖音号"
                v-model="formData.dyid"
                :rules="[{ required: true, message: '请输入抖音号'}]"

              >
              </van-field>
            </div>
            <div>
              <van-field
                v-model="formData.phone"
                id="phone"
                input-align="center"
                autocomplete="off"
                placeholder="联系方式"
                :rules="[{ required: true, message: '请输入联系方式'}]"
              ></van-field>
            </div>
            <div>
              <van-button class="submit" native-type="submit"></van-button>
            </div>
          </van-form>
        </div>
        <div class="ren">
          <img
            src="https://www.chinanola.com/static/img/flow/nba/qiuxing3.png"
            alt=""
          />
        </div>
      </section>
    </div>
  </div>
</template>

<script>

export default {
  name: "nba",
  data() {
    return {
      showTop: false,
      showSt: false,
      moreDataShow: false,
      talentList: [
        {
          id: 1,
          title: "NBA赛况",
        },
        {
          id: 2,
          title: "球场三分钟",
        },
        {
          id: 3,
          title: "篮球小历史",
        },
        {
          id: 4,
          title: "篮球冷知识",
        },
        {
          id: 5,
          title: "球场X秘书",
        },
        // {
        //   id: 6,
        //   title: "篮球人物",
        // },
        // {
        //   id: 7,
        //   title: "篮球日常",
        // },
        // {
        //   id: 8,
        //   title: "之关于篮球-XC",
        // },
        // {
        //   id: 9,
        //   title: "湖人队之家",
        // },
        // {
        //   id: 10,
        //   title: "篮球特效工厂",
        // },
        // {
        //   id: 11,
        //   title: "关于篮球",
        // },
        // {
        //   id: 12,
        //   title: "詹詹的brother",
        // },
        // {
        //   id: 13,
        //   title: "紫金军团",
        // },
        // {
        //   id: 14,
        //   title: "篮球风云WaveBall",
        // },
        // {
        //   id: 15,
        //   title: "篮球视觉（小痞）",
        // },
        // {
        //   id: 16,
        //   title: "篮球小人物",
        // },
        // {
        //   id: 17,
        //   title: "四点篮球社区",
        // },
        // {
        //   id: 18,
        //   title: "解说员老郑",
        // },
        // {
        //   id: 19,
        //   title: "篮球社区",
        // },
        // {
        //   id: 20,
        //   title: "篮球地带",
        // },
        // {
        //   id: 21,
        //   title: "七叶篮球",
        // },
        // {
        //   id: 22,
        //   title: "篮球联萌",
        // },
        // {
        //   id: 23,
        //   title: "蜗壳体育",
        // },
        // {
        //   id: 24,
        //   title: "詹姆斯之家",
        // },
        // {
        //   id: 25,
        //   title: "Mvp篮球",
        // },
        // {
        //   id: 26,
        //   title: "詹詹的WiFi",
        // },
        // {
        //   id: 27,
        //   title: "ForLeBron",
        // },
        // {
        //   id: 28,
        //   title: "偏爱库里",
        // },
        // {
        //   id: 29,
        //   title: "欧文动态",
        // },
      ],
      formData: {
        dyid: "",
        dyname: "",
        phone: "",
      },
    }
  },
  methods: {
      onSubmit: function() {
                this.$notify({
                    message: '提交成功！',
                    type: 'success'
                })
        this.$ajax.post("/sign" ,this.formData).then(res=>{
            if( res.status == 200 ){
                this.$notify({
                    message: '提交成功！',
                    type: 'success'
                })
            }else{
                this.$notify("系统繁忙，请稍后再试~")
            }
        $("#signform")[0].reset();
        }).catch(error => {
          console.log(error);
        })

    },
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/css/global";
@import "../assets/css/function";
@import "../assets/css/index";
// 内容容器
.container {
  padding: 0 15px;
  section {
    > h4 {
      letter-spacing: 4px;
      color: #535353;
      font-weight: 700;
      line-height: 1em;
      text-align: center;
      margin-bottom: 10px;
    }
    > p {
      letter-spacing: 1px;
      line-height: 1.6em;
      color: #535353;
      text-align: center;
    }
  }
}

#page {
  background: url(../assets/img/flow/digitalcontent/nba_bg.png);
  background-size: 100%;
}

.h1-wrap {
  padding-top: 10rem;
  position: relative;
  > h4 {
    width: 50%;
    margin: 0 auto;
    margin-bottom: 1rem !important;
    p {
      margin-top: 5%;
      color: #fff;
      letter-spacing: 1px;
    }
  }
  .text-content {
    p {
      letter-spacing: 1px;
      font-family: arial, helvetica, sans-serif;
      font-size: 0.8rem;
      line-height: 2em;
      text-align: center;
      color: #fff;
    }
  }
}
.h2-wrap {
  padding: 2rem 0;
  > h4 {
    width: 50%;
    margin: 0 auto;
    margin-bottom: 1rem !important;
  }
  .content-wrap {
    .content {
      display: flex;
      flex-wrap: wrap;
      .item-wrap {
        width: 29%;
        border-radius: 50%;
        margin-bottom: 5%;
        margin-right: 2%;
        margin-left: 2%;
        .img-wrap {
          background-color: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
          padding: 1rem;
          img {
            border-radius: 50%;
          }
        }
        .text-div {
          text-align: center;
          color: #fff;
          margin-top: 10%;
        }
      }
    }
    .more-data {
      color: #fff;
      display: flex;
      justify-content: center;
      span {
        display: block;
        padding: 5px 20px;
        border-radius: 10px;
        border: 2px solid #fff;
        cursor: pointer;
      }
    }
  }
}
.sign {
  background: url("../assets/img/flow/digitalcontent/sign_bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  min-height: 21rem;
  .content-wrap {
    padding: 1rem;
    .title {
      text-align: center;
      margin: .5rem 0;
      h4{
        color: #fff;
      }
    }
    #signform {
      width: 80%;
      margin: 0 auto;
      > div {
        margin-bottom: .5rem;
        display: flex;
        justify-content: center;
      }
      .van-cell {
        background-color: rgba(255, 255, 255, 0.5);
        border: 0;
        color: #000;
        text-align: center;
        border-radius: 10px;
        padding: 0.3rem .5rem;
      }
      .van-field__control{
        background-color: rgba(255, 255, 255, 0.5);
      }
      ::-webkit-input-placeholder {
        color: #535353;
        font-weight: 400;
      }

    }
  }
  .ren {
    position: absolute;
    right: -.5rem;
    top: -1rem;
    width: 5rem;
    height: 5rem;
  }
  .submit {
    margin: 0 auto;
    cursor: pointer;
    background: url("https://www.chinanola.com/static/img/flow/nba/icon_tj.png");
    background-size: 100%;
    background-repeat: no-repeat;
    width: 70%;
    height: 100px;
    border: 0;
  }
}

.div__content {
  width: 70%;
}
</style>



// WEBPACK FOOTER //
// src/page/nba.vue